﻿
import { GroCommon } from './common';

/*------------------------------------*\
    #MANAGE-ELECTED
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.manageElected = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {
        if ($(".js-add-elected").length) {
            priv.addEmailValidation();
            priv.addCreateUserValidation();
            priv.bindEvents();
            priv.loadAllDistricts();
            priv.loadElectedForDistrict(400);
            priv.loadDistrictsForElected(0);
        }
    };

    /**
     * Bind events
     */
    priv.bindEvents = function () {

        var dialogType = GroCommon.modalInfoClass;

        var fillContentToModal = function (dialogId, header, content, openDialog, dialogType) {
            var $dialogArea = $(dialogId);
            var $iconElement = $dialogArea.find("span.popup-type");
            if (dialogType) {
                $iconElement.removeClass("hidden");
                $iconElement.addClass(GroCommon.getModalIconClass(dialogType));
            } else {
                $iconElement.addClass("hidden");
            }

            $dialogArea.find(".lm__wide-modal__title").html(header);
            $dialogArea.find("p").append(content);
            $dialogArea.find(".btn-ok").on("click", function () {
                $dialogArea.addClass("hidden");
            });
            if (openDialog) {
                $dialogArea.removeClass("hidden");
            }
        };
        var clearContentToModal = function (dialogId) {
            var dialogArea = $(dialogId);
            dialogArea.find("span.alert-icon.popup-type").removeClass("warning success info-icon");
            dialogArea.find(".lm__wide-modal__title").html("");
            dialogArea.find("p").html("");
            dialogArea.find(".btn-ok").unbind("click");
        };
        /**
         * Check user
         */
        $(document).on("submit", "#js-me-check-user", function (e) {
            e.preventDefault();
            var form = $(this).closest("form");
            if (form.valid()) {
                var formArray = form.serializeArray();
                $(".js-allready-elected").addClass("hidden");
                $(".js-existing-user-information").hide();
                $(".js-create-user").hide();
                $.ajax({
                    dataType: "json",
                    url: "/api/manage-elected/find-existing",
                    type: "post",
                    data: formArray,
                    cache: false,
                    success: function(data) {
                        if (data && !$.isEmptyObject(data)) {
                            if (data.isElected) {
                                $(".js-allready-elected").removeClass("hidden");
                            } else {
                                $(".js-existing-user-information").slideDown("fast");
                                $(".js-user-name").text(data.firstName + " " + data.lastName);
                                $(".js-user-telephone").text(data.telephone);
                                $(".js-user-mobile").text(data.mobile);
                                $(".js-user-email").text(data.email);
                                //$(".js-user-ssn").text(data.ssn);
                                $(".js-user-email").prop("href", "mailto:" + data.email);
                            }
                        } else {
                            $(".js-create-user").slideDown("fast");
                        }
                    },
                    error: function (jqXHR, status, exception) {
                        var errorMessage = "Det uppstode fel vid kontrollera användare som förtroendevald";
                        if (jqXHR.status == 404) {
                            errorMessage = "User " + email + " finns ej!";
                        }
                        clearContentToModal("#dialogArea");
                        fillContentToModal("#dialogArea",
                            errorMessage,
                            "",
                            true,
                            dialogType.error);
                    }
                });
            }
        });

        /**
         * Create new user
         */
        $(document).on("submit", ".js-create-user", function (e) {
            e.preventDefault();
            var form = $(this).closest("form");
            if (form.valid()) {
                var formArray = form.serializeArray();
                var email = $("#js-me-check-user .js-add-owner-epost");
                formArray.push({
                    name: "email",
                    value: email.val()
                });
                $.ajax({
                    dataType: "json",
                    url: "/api/manage-elected/add-new-user",
                    type: "post",
                    data: formArray,
                    cache: false,
                    success: function (data) {
                        if (data && !$.isEmptyObject(data)) {
                            $(".js-user-name").text(data.firstName + " " + data.lastName);
                            $(".js-user-telephone").text(data.telephone);
                            $(".js-user-mobile").text(data.mobile);
                            $(".js-user-email").text(data.email);
                            $(".js-user-email").prop("href", "mailto:" + data.email);
                            $(".js-check-user").hide();
                            $(".js-create-user").hide();
                            $(".js-add-district").show();
                            $(email).val("");
                            $(form).trigger("reset");
                        }
                    },
                    error: function (jqXHR, status, exception) {
                        var errorMessage = "Det uppstode fel vid lägg till användare som förtroendevald";
                        if (jqXHR.status == 404) {
                            errorMessage = "User " + email + " finns ej!";
                        }
                        clearContentToModal("#dialogArea");
                        fillContentToModal("#dialogArea",
                            errorMessage,
                            "",
                            true,
                            dialogType.error);
                    }
                });

            }
        });

        /**
         * Filter user list
         */
        $(".js-filter-user-list").on("input change", function () {
            var list = $(this).data("list");
            var noHits = $(this).data("no-hits");
            var query = $(this).val();
            var anyMatch = false;
            var anyFiltered = false;

            $(".js-search-query").text(query);

            // Collapse all accordion elements before filtering
            farmday.modules.toggle.collapseAll(list);

            // Loop through every table row and search for query
            $(list).find("button:not(" + noHits + ")").each(function () {
                var control = $(this);
                var controlData = control.text().toLowerCase();
                var queryFound = controlData.indexOf(query.toLowerCase()) !== -1;

                if (queryFound) {
                    anyMatch = true;
                    control.show();
                } else {
                    control.hide();
                    anyFiltered = true;
                }
            });

            // Show or hide no hits message
            anyMatch ? $(noHits).hide() : $(noHits).show();

            // Show or hide show list button
            anyFiltered ? $(".js-user-list-show-all-btn").css("display", "inline-block") : $(".js-user-list-show-all-btn").hide();
        });

        /**
         * Show entire user list
         */
        $(".js-user-list-show-all-btn").on("click", function (e) {
            e.preventDefault();
            var queryElement = $(this).data("query-element");

            $(queryElement).val("").trigger("change");
        });

        /**
         * Show add elected form
         */
        $(".js-show-add-elected-form").on("click", function () {
            $(".js-add-elected").slideToggle("fast");
        });

        /**
         * Close add elected form
         */
        $(".js-cancel-add-elected").on("click", function () {
            $(".js-add-elected").slideUp("fast", function () {
                $(".js-existing-user-information").hide();
                $(".js-add-district").hide();
                $(".js-create-user").hide();
                $(".js-check-user").show();
                $(".js-add-owner-epost").val("");
            });
        });

        /**
         * Cancel add existing user as elected
         */
        $(".js-cancel-add-elected-existing-user").on("click", function () {
            $(".js-existing-user-information").slideUp("fast");
            $(".js-add-owner-epost").val("");
        });

        /**
         * Add elected
         */
        $(".js-add-as-elected").on("click", function () {
            $(".js-check-user").hide();
            $(".js-add-district").show();
        });

        /**
         * Save elected
         */
        $(".js-save-as-elected").on("click", function () {
            var email = $("#js-user-add-email").text();
            var form = $(this).closest("form");
            var districts = form.serializeArray();
            $.ajax({
                dataType: "json",
                url: "/api/manage-elected/add-existing-user",
                type: "post",
                data: {
                    email: email,
                    districts: districts
                },
                cache: false,
                success: function (data) {
                    if (data) {
                        $(".js-add-elected").slideUp("fast",
                            function() {
                                $(".js-existing-user-information").hide();
                                $(".js-add-district").hide();
                                var district = $("#js-all-districts").val();
                                priv.loadElectedForDistrict(parseInt(district));
                                $(".js-add-owner-epost").val("");
                                $(".js-check-user").show();
                            });
                    } else {
                        clearContentToModal("#dialogArea");
                        fillContentToModal("#dialogArea",
                            "Det uppstode fel vid lägg till användare som förtroendevald",
                            "",
                            true,
                            dialogType.error);
                    }
                },
                error: function (jqXHR, status, exception) {
                    var errorMessage = "Det uppstode fel vid lägg till användare som förtroendevald";
                    if (jqXHR.status == 404) {
                        errorMessage = "User " + email + " finns ej!";
                    }
                    clearContentToModal("#dialogArea");
                    fillContentToModal("#dialogArea",
                        errorMessage,
                        "",
                        true,
                        dialogType.error);
                }
            });
        });

        $(document).on("click", ".js-save-edit-elected", function () {
            var form = $(this).closest("form");
            var email = $(form).find(".js-user-add-email").text();
            var districts = form.serializeArray();
            $.ajax({
                dataType: "json",
                url: "/api/manage-elected/add-existing-user",
                type: "post",
                data: {
                    email: email,
                    districts: districts
                },
                cache: false,
                success: function (data) {
                    if (data) {
                        var district = $("#js-all-districts").val();
                        priv.loadElectedForDistrict(parseInt(district));
                    }
                },
                error: function (jqXHR, status, exception) {
                    var errorMessage = "Det uppstode fel vid lägg till användare som förtroendevald";
                    if (jqXHR.status == 404) {
                        errorMessage = "User " + email + " finns ej!";
                    }
                    clearContentToModal("#dialogArea");
                    fillContentToModal("#dialogArea",
                        errorMessage,
                        "",
                        true,
                        dialogType.error);
                }
            });
        });

        $(document).on("click", ".js-cancel-edit-elected", function () {
            farmday.modules.toggle.collapseAll(".js-user-list");
        });

        $(document).on("click", ".js-delete-elected", function () {
            var user = $(this).data("user");
            $.ajax({
                dataType: "json",
                url: "/api/manage-elected/delete-elected",
                type: "post",
                data: {
                    userName: user
                },
                cache: false,
                success: function (data) {
                    if (data) {
                        var district = $("#js-all-districts").val();
                        priv.loadElectedForDistrict(parseInt(district));
                    }
                },
                error: function (jqXHR, status, exception) {
                        var errorMessage = "Det uppstode fel vid koppla bort användare som förtroendevald";
                        if (jqXHR.status == 404) {
                            errorMessage = "User " + email + " finns ej!";
                        }
                        clearContentToModal("#dialogArea");
                        fillContentToModal("#dialogArea",
                            errorMessage,
                            "",
                            true,
                            dialogType.error);
                    }
            });
        });

        /**
         * Go back from add district to select user
         */
        $(".js-back-from-add-district-to-select-user").on("click", function () {
            $(".js-add-district").hide();
            $(".js-check-user").show();
        });

        /**
         * Add district to user
         */
        $(document).on("click", ".js-add-district-to-elected", function () {
            var districtContainer = $(this).closest(".js-district-container");
            var districtSelect = districtContainer.find(".js-district-dropdown");
            var districtTarget = districtContainer.find(".js-district-list");
            var selected = districtSelect.find(":selected");
            var emptyMessage = districtContainer.find(".js-no-district-chosen");
            if (selected.val()) {
                var data = { Name: selected.val(), ReadRoleId: selected.data("read"), WriteRoleId: selected.data("write"), WriteRights: false };
                var template = $.templates("#elected-district-template");
                $(selected).remove();
                $(districtTarget).append(template.render(data));
                emptyMessage.addClass("is-hidden");
            }
        });

        /**
         * Delete district from user
         */
        $(document).on("click", ".js-delete-district", function () {
            var del = $(this);
            var data = { Name: del.data("name"), ReadRoleId: del.data("read"), WriteRoleId: del.data("write") };
            var template = $.templates("#elected-add-district-dropdown-template");
            var districtContainer = $(this).closest(".js-district-container");
            var districtSelect = districtContainer.find(".js-district-dropdown");
            var list = districtContainer.find(".js-district-list");

            districtSelect.append(template.render(data));

            $(this).closest("li").remove();

            var districtCount = list.children().length;

            if (districtCount === 0) {
                var emptyMessage = districtContainer.find(".js-no-district-chosen");
                emptyMessage.removeClass("is-hidden");
            }
        });

        /**
         * Show all districts
         */
        $(document).on("change", "#js-all-districts", function () {
            var id = $(this).val();
            priv.loadElectedForDistrict(parseInt(id));
        });

        /**
         * Expand elected in list
         */
        $(document).on("click", ".js-expand-elected", function (e) {
            e.preventDefault();
            var row = $(this).closest(".js-elected");
            var details = row.find(".js-elected-details");
            var showDetails = row.find(".show-details");
            var hideDetails = row.find(".js-hide-details");
            var isExpanded = details.hasClass("is-expanded");

            if (isExpanded) {
                details.removeClass("is-expanded").slideUp("fast", function () {
                    showDetails.attr("colspan", "1");
                    row.removeClass("is-expanded");
                    hideDetails.show();
                });
            } else {
                row.addClass("is-expanded");
                hideDetails.hide();
                showDetails.attr("colspan", "2");
                details.addClass("is-expanded").slideDown("fast");
            }

        });

    };
    /**
       * Fill dropdown and list with data when pressing toggle
       */
        $(document).on("click", ".js-elected-toggle", function (e) {
            e.preventDefault();
            if ($(this).hasClass("is-active")) {
            } else {
                var userId = $(this).data("user");
                $.when(priv.loadDistrictsForElectedAjax(userId), priv.loadDistrictsForElectedAjax(0)).done(function (user, all) {
                    var districtContainer = $("#elected-container-" +userId);
                    var dropDown = districtContainer.find(".js-district-dropdown");
                    $(dropDown).empty();
                    var list = districtContainer.find(".js-district-list");
                    $(list).empty();
                    var filteredDistricts = $.grep(all[0], function (el, i) {
                        var save = true;
                        $.each(user[0], function(ui, d) {
                            if (el.Name == d.Name)
                                save = false;
                        });
                        return save;
                                });
                    var dropdownTemplate = $.templates("#elected-add-district-dropdown-template");
                    $.each(filteredDistricts, function (i, t) {
                        $(dropDown).append(dropdownTemplate.render(t));
});

                    var listTemplate = $.templates("#elected-district-template");
                    $.each(user[0], function (i, t) {
                        $(list).append(listTemplate.render(t));
                    });

                    var districtCount = user[0].length;
                    var emptyMessage = districtContainer.find(".js-no-district-chosen");
                    if (districtCount === 0) {
                        emptyMessage.removeClass("is-hidden");
                    } else {
                        emptyMessage.addClass("is-hidden");
                    }
                    });
            }
            });
    /**
 * Load all districts and fill filter dropdown
 */

    priv.loadAllDistricts = function () {
        $("#js-add-districts").empty();
        $.ajax({
            dataType: "json",
            url: "/api/manage-elected/district-groups",
            type: "get",
            cache: false,
            success: function (data) {
                if (data) {
                    var template = $.templates("#elected-all-district-dropdown-template");
                    $.each(data, function (i, t) {
                        $("#js-all-districts").append(template.render(t));
                    });
                }
            },
            error: function () {
            }
        });
    };

    /**
     * Load districts for elected and fill add dropdown
     * @param {string} id
     */
    priv.loadDistrictsForElected = function (id) {
        $("#js-add-district-dropdown").empty();
        $.when(priv.loadDistrictsForElectedAjax(id)).done(function (data) {
            if (data) {
                var template = $.templates("#elected-add-district-dropdown-template");
                $.each(data, function (i, t) {
                    $("#js-add-district-dropdown").append(template.render(t));
                });
            }
        });
    };

    /**
     * Load elected for district and fill the list
     * @param {string} id
     */
    priv.loadElectedForDistrict = function (id) {
        $(".js-user-list").empty();
        $.when(priv.loadElectedForDistrictAjax(id)).done(function (data) {
            if (data) {
                var template = $.templates("#elected-user-list-template");
                $.each(data, function (index, user) {
                    user.Index = index;
                    $(".js-user-list").append(template.render(user));
                });
            }
        });
    };

    priv.loadDistrictsForElectedAjax = function (id) {
        return $.ajax({
            dataType: "json",
            url: "/api/manage-elected/districts-for-elected",
            type: "post",
            data: { id: id },
            cache: false,
            success: function (data) {
            },
            error: function () {
            }
        });
    };

    priv.loadElectedForDistrictAjax = function (id) {
        return $.ajax({
            dataType: "json",
            url: "/api/manage-elected/elected-district",
            type: "post",
            data: { id: id },
            cache: false,
            success: function (data) {
            },
            error: function () {
            }
        });
    };

    priv.addCreateUserValidation = function () {
        if ($().validate) {
            $(".js-create-user").validate({
                errorElementClass: "error",
                errorClass: "error-item",
                errorElement: "span",
                //errorLabelContainer: ".js-validate-error",
                //wrapper: "li",
                rules: {
                    firstName: {
                        required: true
                    },
                    lastName: {
                        required: true
                    },
                    mobile: {
                        required: true,
                        mobileSE: true
                    },
                    telephone: {
                        phoneSE: true
        }
                },
                messages: {
                    firstName: {
                        required:  "Du måste ange förnamn"
                    },
                    lastName: {
                        required: "Du måste ange efternamn"
                    },
                    mobile: {
                        required: window["validationMessage"].mobileSE.required,
                        mobileSE: window["validationMessage"].mobileSE.valid
                    },
                    telephone: {
                        phoneSE: window["validationMessage"].phoneSE.valid
                    }
                }
            });
        }
    };

     priv.addEmailValidation = function () {
        if ($().validate) {
            $("#js-me-check-user").validate({
                errorElementClass: "error",
                errorClass: "error-item",
                errorElement: "span",
                rules: {
                    email: {
                        required: true,
                        email: true
                    }
                },
                messages: {
                    email: {
                        required: "Du måste ange en E-postadress",
                        email: "Ange en korrekt epost"

                    }
                }
            });
        }
    };

    // Initialize module
    $(function () {
        priv.init();
    });
})();
